import localStorage from 'redux/models/localStorage';
import { TOKEN, GET_TOKEN, SET_TOKEN } from '../actions/token';

const initialState = { token: localStorage.getItem(TOKEN) };

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOKEN:
      return { token: state.token };

    case SET_TOKEN:
      localStorage.setItem(TOKEN, action.token);
      return { token: action.token };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/token.js